import React from 'react';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';

/**
 * One labelled field in a ShareDialogFrame: a label, optional helper text under it, then the
 * select passed as children.
 */
export const ShareField = ({ label, helperText, children }) => (
	<FormControl>
		<FormLabel>{label}</FormLabel>
		{helperText && <FormHelperText sx={{ marginLeft: 0 }}>{helperText}</FormHelperText>}
		{children}
	</FormControl>
);
